import config from "../../../../store/sqftConfig";
import COLOR_THEMES from "../../../../store/colorThemes";

export default class Color {
  static getOutlineHoverStrokeStyle() {
    switch (config.highlight.type) {
      case 'edge':
      default:
        return COLOR_THEMES[config.activeTheme].active_transparent;
      case 'backsplash':
        return COLOR_THEMES[config.activeTheme].primary_hover;
      case 'wall':
        return 'rgba(0,0,0,0.5)';
    }
  }

  static getOutlineStrokeStyle(type) {
    switch (type) {
      case 'edge':
        return COLOR_THEMES[config.activeTheme].active;
      case 'backsplash':
        return COLOR_THEMES[config.activeTheme].primary;
      case 'wall':
        return '#000000';
      default:
        return COLOR_THEMES[config.activeTheme].active_transparent;
    }
  }
}
